import { Stack, styled, Tabs } from '@mui/material';

import { AppModal } from '@/components/Modals/AppModal';
import { colors } from '@/theme/variables';

const modalHeight = '90vh';
const tabsSidebarWidth = 287;

export const TabSectionStyled = styled(Stack)(() => ({
  padding: 20,
  width: '100%',
  marginLeft: tabsSidebarWidth,
  height: `calc(${modalHeight} - 50px)`,
  overflowY: 'auto',
}));

export const ModalHeader = styled(Stack)(() => ({
  flexDirection: 'row',
  padding: '10px 10px',
  margin: '-20px -20px 0',
  borderBottom: `1px solid ${colors.grey[20]}`,
  zIndex: 3,
  '.title': {
    marginRight: 'auto',
    fontWeight: 500,
    fontSize: '1.25rem',
    lineHeight: 1.6,
  },
}));

export const AppModalDomestic = styled(AppModal)(() => ({
  overflow: 'hidden',
  '& .modal-content': {
    height: modalHeight,
  },
}));

export const TabsDomesticIncident = styled(Tabs)(({ theme }) => ({
  position: 'absolute',
  top: 40,
  left: -15,
  bottom: -20,
  padding: 2,
  borderRight: 1,
  borderColor: 'divider',
  width: tabsSidebarWidth,
  '& .MuiTab-textColorPrimary': { color: theme.palette.text.primary },
  '& .MuiButtonBase-root.Mui-selected': { color: '#fff' },
}));
